<template>
    <div :class="navigateButtons && 'p-ai-center p-grid p-jc-center'">
    <div
            :class="navigateButtons && 'p-col'"
        >

                <MultiSelect
                        v-on="listeners"
                        :filter="true"
                        filterPlaceholder="חפש שעה"
                        emptyFilterMessage=" לא נמצאה שעה"
                        placeholder="שעה"
                        data-key="id"
                        :key="DropdownKey"
                        dataKey="id"
                        optionLabel="hebrewName"
                        v-model="selectLesson"
                        :options="getLessons"
                        @change="onSelect"
                >
                </MultiSelect>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {mapState} from "vuex";

export default {
    props: {
        storageName: {
            type: String,
            default: "default"
        },
        navigateButtons:{
            type: Boolean,
            default: false
        },
        returnId:{
            type: Boolean,
            default: false
        },
        useStore:{
            type: Boolean,
            default: false
        },
        defaultValue:{
            type: Array,
            default: null
        },
        specificOptions:{
            type: Array,
            default: null
        },
        value: null
    },
    name: "MultiSelectLessonTime",
    data: () => ({
        selectLesson: [],
        DropdownKey: 1
    }),
    methods: {
        onSelect({originalEvent, value}) {
            if(this.useStore){
                Vue.ls.set(`multiSelectLessonTime_${this.storageName}`, value)
            }
            this.selectLesson = value
            this.$emit('onSelect', this.returnId ?  value?.map((val) => val.id) : value);
            this.$emit('input', this.returnId ?  value?.map((val) => val.id)  : value);

        },
        navigateDays(isAdd) {
            const index = this.getLessons.findIndex(
                (day) => day.id === this.selectLesson.id
            );
            const subject =
                this.getLessons[
                ((isAdd ? index + 1 : index - 1) + this.getLessons.length) %
                this.getLessons.length
                    ];
            this.onSelect({originalEvent: null, value: subject})

        },
    },
    computed: {
        getLessons() {
            if (this.specificOptions){
                const specificLessons = this.lessonTime?.filter((lesson) => {
                    return  this.specificOptions.includes(lesson.id)
                })
                return specificLessons
            }
            return this.lessonTime ?? []

        },

        listeners() {
            return {
                ...this.$listeners,
                input: event => {
                    this.$emit('input', event?.target?.value);
                }
            };
        },
        ...mapState([ "lessonTime"]),
    },
    watch: {
        selectLesson(newValue, oldValue) {
        }
    },
    created() {
        if (this.useStore) {
            const restoreSubject = Vue.ls.get(`multiSelectLessonTime_${this.storageName}`)

            if (restoreSubject && this.lessonTime.some(g => g.id === restoreSubject.id)){
                this.onSelect({originalEvent: null, value: restoreSubject})
            } else {
                if (this.defaultFirst){
                    this.onSelect({originalEvent: null, value: this.lessonTime[0]})
                }
            }
        }  else {
            if (this.defaultFirst){
                this.onSelect({originalEvent: null, value: this.lessonTime[0]})
            }
        }
        if (this.defaultValue !== null){
        //
            console.log("this.defaultValue")
            const final = []
            this.defaultValue.forEach(d => {
               const lesson = this.lessonTime.find(l => l.id === d)
                final.push(lesson)
            })
            console.log(this.defaultValue)
            console.log("final")
            console.log(final)
            this.selectLesson = final
        //     // this.onSelect()
        // }
        // else if(this.useStore) {
        //     this.selectLesson = Vue.ls.get(`selectLesson_${this.storageName}`) || {id: 0}
        //     this.onSelect()
        }
    }
}
</script>

<style scoped>

</style>